export default "__VITE_ASSET__BQMURnLX__"